// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<>
		<svg
			width={props.width}
			height={props.height}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="9.5" cy="14.5" r="8" stroke={props.color} />
			<circle cx="14.5" cy="9.5" r="8" stroke={props.color} />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.5324 6.5324C7.45628 6.18816 8.45617 6 9.5 6C14.1944 6 18 9.80558 18 14.5C18 15.5438 17.8118 16.5437 17.4676 17.4676C16.5437 17.8118 15.5438 18 14.5 18C9.80558 18 6 14.1944 6 9.5C6 8.45617 6.18816 7.45628 6.5324 6.5324Z"
				fill={props.color}
			/>
		</svg>
	</>
);

export default Icon;
